import React, { useEffect, useState } from "react";
import Section from "../../../components/Section";
import { pageTitle } from "../../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import toast from "react-hot-toast";
import SecondaryButton from "../../../components/SecondaryButton";
import { signInWithEmailAndPassword } from "firebase/auth";
import PageHeader from "../../../components/PageHeader";
import InputField from "../../../components/InputField";
import { auth } from "../../../config/firebaseConfig";
import { BsEye } from "react-icons/bs";
import PasswordInputField from "../../../components/PasswordField";
import axiosInstance from "../../../utils/axiosInstance";
import { addEditExpertise, addEditService, deleteService, fetchDoctorProfile, fetchDoctorServicesList, registerUser, updateUserDetais } from "../../../constants/ApiConstants";
import { Link, redirect, useNavigate } from "react-router-dom";
import SelectField from "../../../components/SelectField";
import SelectField2 from "../../../components/SelectField2";
import { countries } from "../../../utils/countries";
import MobileNumberWithCountryCode from "../../../components/MobileNumberWithCountryCode";
import DatePicker from "react-datepicker";
import { getYYYYmmddFromDate, isDesktop } from "../../../utils/utils";
import { updateUserData } from "../../../store/appSlice";
import CommonMobileHeader from "../../../components/Header/CommonMobileHeader";
import FullPageLoader from "../../../components/FullPageLoader";
import ListEmptyText from "../../../components/ListEmptyText";
import MyModal from "../../../components/MyModal";
import Spinner from "../../../components/Spinner";

export default function ManageExpertise() {
  pageTitle("Manage Expertise");

  const [loading, setLoading] = useState(false);
  const doctorId = useSelector((state) => state.appSlice.doctorData?.id);
  const [doctorDetail, setDoctorDetail] = useState(null);

  const [editExpertiseData, setEditExpertiseData] = useState();
  const [deleteExpertiseId, setDeleteExpertiseId] = useState("");
  const [editExpertiseModalOpen, setEditExpertiseModalOpen] = useState(false);
  const [deleteExpertiseModalOpen, setDeleteExpertiseModalOpen] = useState(false);
  const [addExpertiseModalOpen, setAddExpertiseModalOpen] = useState(false);
  const [addExpertiseData, setAddExpertiseData] = useState(null);

  const [submitting, setSubmitting] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchDoctorDetail();
  }, []);

  const fetchDoctorDetail = () => {
    setLoading(true);
    axiosInstance
      .post(fetchDoctorProfile, {
        doctor_id: doctorId,
      })
      .then((res) => {
        setDoctorDetail(res.data.data);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleEditPress = (expertiseData) => {
    setEditExpertiseData(expertiseData);
    setEditExpertiseModalOpen(true);
  };

  const handleDeletePress = (expertiseData) => {
    setDeleteExpertiseId(expertiseData.id);
    setDeleteExpertiseModalOpen(true);
  };

  const handleOpenAddServiceModal = () => {
    setAddExpertiseModalOpen(true);
    setAddExpertiseData({ title: "" });
  };

  const closeAddModal = () => setAddExpertiseModalOpen(false);
  const closeEditModal = () => setEditExpertiseModalOpen(false);
  const closeDeleteModal = () => setDeleteExpertiseModalOpen(false);

  const onAddSubmit = () => {
    if (!editExpertiseData?.title === "") {
      toast.error("Please provide Expertise title");
      return;
    }
    setSubmitting(true);
    axiosInstance
      .post(addEditExpertise, {
        doctor_id: doctorId,
        title: addExpertiseData?.title,
        type: 1,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Expertise added successfully.");
          setAddExpertiseData("");
          setAddExpertiseModalOpen(false);
          fetchDoctorDetail();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const onEditSubmit = () => {
    if (!editExpertiseData?.title === "") {
      toast.error("Please provide Expertise title");
      return;
    }
    setSubmitting(true);
    axiosInstance
      .post(addEditExpertise, {
        doctor_id: doctorId,
        title: editExpertiseData?.title,
        expertise_id: editExpertiseData?.id,
        type: 2,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Expertise updated successfully.");
          setEditExpertiseData("");
          setEditExpertiseModalOpen(false);
          fetchDoctorDetail();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  const onDeleteClick = () => {
    setSubmitting(true);
    axiosInstance
      .post(addEditExpertise, {
        doctor_id: doctorId,
        expertise_id: deleteExpertiseId,
        type: 3,
      })
      .then((res) => {
        if (res.data?.status) {
          toast.success("Expertise deleted successfully.");
          setDeleteExpertiseId("");
          setDeleteExpertiseModalOpen(false);
          fetchDoctorDetail();
        } else {
          toast.error(res.data?.message);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <Wrapper>
      {loading ? (
        <FullPageLoader />
      ) : (
        <Section topMd={0} topLg={0} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
          <div className="content-wrapper d-flex flex-column px-3 gap-1 justify-content-center mx-auto">
            <CommonMobileHeader
              canBack
              title="Expertise"
              trailing={
                <button type="button" className="bg-success-surface px-3 rounded" onClick={handleOpenAddServiceModal}>
                  Add Expertise
                </button>
              }
            />
            <div className="row">
              <div className="col-md-6">
                <div className="py-3 bg-white">
                  <strong className="text-dark">MANAGE EXPERTISE</strong>
                  <p className="text-grey2 fs-normal">Example: Allergies/Immunologists, Anesthesiologists, Cardiologists, Dermatologists, Etc.</p>
                </div>
              </div>
              <div className="col-md-6">
                {!loading && doctorDetail && doctorDetail?.expertise.length === 0 && <ListEmptyText text={"No Expertise added yet."} />}
                {!loading && doctorDetail && doctorDetail?.expertise.length > 0 && (
                  <div className="w-full">
                    {doctorDetail?.expertise.map((Expertise) => (
                      <div key={Expertise.id} className="d-flex justify-content-between bg-grey2 mb-2 rounded">
                        <strong className="fs-normal text-grey2 fw-normal px-3 py-2  ">{Expertise.title}</strong>
                        <div className="d-flex gap-2">
                          <button type="button" className="bg-warning-surface px-3 rounded" onClick={() => handleEditPress(Expertise)}>
                            Edit
                          </button>
                          <button type="button" className="bg-danger-surface px-3 rounded" onClick={() => handleDeletePress(Expertise)}>
                            Delete
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </Section>
      )}
      {/* Edit Expertise Modal */}
      <MyModal isOpen={editExpertiseModalOpen} modalTitle={"Edit Expertise"} onClose={closeEditModal}>
        <div className="d-flex flex-column gap-2 mt-3">
          <InputField name={"expertiseName"} value={editExpertiseData?.title} onChange={(e) => setEditExpertiseData({ ...editExpertiseData, title: e.target.value })} />
          <SecondaryButton title="Continue" onClick={onEditSubmit} loading={submitting} />
        </div>
      </MyModal>
      {/* Add Expertise Modal */}
      <MyModal isOpen={addExpertiseModalOpen} modalTitle={"Add Expertise"} onClose={closeAddModal}>
        <div className="d-flex flex-column gap-2 mt-3">
          <InputField name={"expertiseName"} value={addExpertiseData?.title} onChange={(e) => setAddExpertiseData({ ...addExpertiseData, title: e.target.value })} />
          <SecondaryButton title="Continue" onClick={onAddSubmit} loading={submitting} />
        </div>
      </MyModal>
      {/* Delete Modal */}
      <MyModal isOpen={deleteExpertiseModalOpen} modalTitle={"Delete Expertise"} onClose={closeDeleteModal}>
        <div className="d-flex flex-column gap-2 mt-3">
          <SecondaryButton title="Delete" onClick={onDeleteClick} loading={submitting} />
        </div>
      </MyModal>
    </Wrapper>
  );
}
const Wrapper = styled.div``;
